﻿import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type CreateOrderTabProps = {
    label: string;
};

const CreateOrderRoute = '/orders/new';
const CreateOrderPhotographerBooking = '/se360/photographerbooking';
const DuskPhotographerBooking = '/se360/duskphotographybooking';

let routes = [CreateOrderRoute, CreateOrderPhotographerBooking, DuskPhotographerBooking];

function CreateOrderTab({ label, ...props }: CreateOrderTabProps) {
    function handleClick() {
        history.push(CreateOrderRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={CreateOrderRoute} />;
}

function TranslatedCreateOrderTab(props) {
    const label = Translate('header/nav/new-order');
    return <CreateOrderTab {...props} label={label} />;
}

TranslatedCreateOrderTab.routes = routes;

export default TranslatedCreateOrderTab;
